import type { NativePlatform } from './native.types';

export const MAX_PATH_LENGTH = 2048;
export const BASE64_OUTPUT_BLOCK_LENGTH = 4;
export const AES_KEY_LENGTH_BYTES = 32;
export const AES_IV_LENGTH_BYTES = 12;
export const AES_KEY_LENGTH_BITS = 256;
export const BASE64_CHUNK_SIZE = 0x8000;

export const NATIVE_ALG_CONFIG = {
  alg: 'RSA-OAEP+AES-GCM',
  hash: 'SHA-1' as const,
} as const;

export const NATIVE_PLATFORM_KEYS: Record<
  NativePlatform,
  { kid: string; spkiPem: string }
> = {
  android: {
    kid: 'android-v1',
    spkiPem: [
      '-----BEGIN PUBLIC KEY-----',
      'MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEA5aQ6m7Sihv+7tw2JQu1S',
      'N04we+qruBLFfeX2RiAPUzVGMN71aXPPiGBGKDiuhR1MjA1fs3UM42ecf/FKIFLY',
      'p+smtoXOeMDS8pQoR546MHDMCFO1X+K7zC72yZx+DGJeUMaGXbxP//kvYDcYsEMz',
      'zjdoBcXKOMLX/04N3a2q8PFN46k7v0BnoUlmvwEMGqNOqFBrChe2Xz61Haj5srZ6',
      'tZ7QG+AQTKoYs0vOh4HmN5vNCKkmDM0W/XODveN7Wfo58FuUjLiSgo8eN/OtlgvA',
      'VqvcKC1zLG4N8EmbV7SPKGeFwzjiA7EVuRzfTBLWnEdZllJrdLdrdRV1+HKViPd8',
      'TQIDAQAB',
      '-----END PUBLIC KEY-----',
    ].join('\n'),
  },
  ios: {
    kid: 'ios-v1',
    spkiPem: [
      '-----BEGIN PUBLIC KEY-----',
      'MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAw3cOWfU9i8SyZNm/XnZU',
      'qHHXfq3DUH0KAQSz432M5IZg9XONh3JWfUs1My1+JMQBxn1/6ZRrRogRGclMhs/f',
      '8zyz/OTYorFsdpQsDifZCPH/O4zDslag+OJLZiEUFWPfIKNs10Juq7nEh9NJcTX3',
      'SPj8T9tHdKGDarWFe2JAo85RMazqM+Q9SvC0zLB/xMjmFgLMP2A219ctu/btpzZN',
      'MdMcz97UYzJP281fA41ueXE04Xo4kE/sVLzFHW3/DBU8ntooCYz0pz2W7jPLg8/3',
      'qSmAAucgeQOimMNNINc8R+Ym2MHbh8j3PXoyA2iZFaohIb0z0VIKGNG52BqmocQg',
      'EQIDAQAB',
      '-----END PUBLIC KEY-----',
    ].join('\n'),
  },
} as const;
